import type { TcgRarityId } from "./types";

export type TcgRarityFilter = "All" | TcgRarityId;

interface TcgRarityTabsProps {
  rarities: TcgRarityId[];
  active: TcgRarityFilter;
  onChange: (value: TcgRarityFilter) => void;
  labels: Record<TcgRarityFilter, string>;
}

export const TcgRarityTabs = ({ rarities, active, onChange, labels }: TcgRarityTabsProps) => {
  const options: TcgRarityFilter[] = ["All", ...rarities];

  return (
    <div
      className="flex gap-2 overflow-x-auto pb-1 [-webkit-overflow-scrolling:touch]"
      role="tablist"
      aria-label={labels.All}
    >
      {options.map((option) => {
        const isActive = active === option;
        return (
          <button
            key={option}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={[
              "shrink-0 rounded-full border px-4 py-2 text-[0.78rem] font-semibold uppercase tracking-[0.06em] transition-colors",
              isActive
                ? "border-light-blue bg-[rgba(56,189,248,0.15)] text-light-blue"
                : "border-[var(--surface-card-border)] bg-[var(--surface-card-bg)] text-[#94a3b8] hover:text-white",
            ].join(" ")}
            onClick={() => {
              onChange(option);
            }}
          >
            {labels[option]}
          </button>
        );
      })}
    </div>
  );
};
